module.exports = __webpack_public_path__ + "img/auditPass.97254968.png";